import { render, staticRenderFns } from "./QuizSlide.vue?vue&type=template&id=7784b2c1&lang=pug"
import script from "./QuizSlide.vue?vue&type=script&lang=ts"
export * from "./QuizSlide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports